import {computed, override, observable} from "mobx";
import {ScoresBarWidgetScoresModel} from "./scores-bar-widget.scores.model";
import {BaseLinkModel} from "../../../../infrastructure/models/link/base-link-model";
import {AllScoresLinkModel} from "../../../../containers/all-scores-container/models/all-scores-container-link-model";
import {DASHBOARD} from "../../../../containers/dashboard-container/dashboard-container.consts";
import {ScoresBarWidgetTerms} from "../../scores-bar-widget.terms";
import {DatetimeUtils} from "../../../../infrastructure/utils/datetime-utils";
import {SportDomainModel} from "../../../../domain/sports/models/sport-domain-model";
import {singleton} from "../../../../infrastructure/decorators/singleton";
import {AppModuleState} from "../../../../core/app/models/app-module.state";
import {ScoresBarWidgetConfig} from "../../scores-bar-widget.config";
import {HREF_SPORT_TYPES} from "../../../../core/app/consts";
import languages from "../../../../core/app/consts/languages";
import {SCORES_BAR} from "../../scores-bar-widget.consts";

@singleton
export class ScoresBarWidgetAllScoresModel extends ScoresBarWidgetScoresModel {
  @observable sportType: SportDomainModel;

  constructor(
    context: Number,
    currentLinkModel: BaseLinkModel,
    terms: ScoresBarWidgetTerms,
    datetimeUtils: DatetimeUtils,
    sportType: SportDomainModel,
    appState: AppModuleState,
    config: ScoresBarWidgetConfig
  ) {
    super(context, currentLinkModel, terms, datetimeUtils, appState, config);

    this.sportType = sportType;
  }

  @override get entityId(): Number {
    return null;
  }

  @override get dateLabel(): String {
    if(!this.date) {
      return null;
    }

    return this.datetimeUtils.toShortNamedDate(this.date)
  }

  @override get arrowPrevLabel(): String {
    const arrowPrevLabel: String  = this.isToday ? this.terms.DATER_PREV_DAY : this.terms.DATER_PREV_DAY_NOT_YESTERDAY;

    return arrowPrevLabel;
  }

  @override get arrowNextLabel(): String {
    const arrowNextLabel: String  = this.isToday ? this.terms.DATER_NEXT_DAY : this.terms.DATER_NEXT_DAY_NOT_TOMORROW;

    return arrowNextLabel;
  }

  @override get arrowClickType(): String {
    return SCORES_BAR.ANALYTICS.ARROW_CLICK_TYPE.arrows;
  }

  @override get linkType(): AllScoresLinkModel {
    return AllScoresLinkModel
  }

  @override get linkModel(): BaseLinkModel {
    return new AllScoresLinkModel(DASHBOARD.FILTERS.all, this.sportType?.nameForURL);
  }

  @override get arrowsClick(): String {
    return SCORES_BAR.ACTION_TYPES.calendarClick;
  }

  @override get shouldRenderLiveToggle(): Boolean {
    return this.isToday;
  }

  @override get shouldRenderDate(): Boolean {
    return true;
  }

  equals(model: ScoresBarWidgetAllScoresModel) {
    let equals = true;

    equals &= model.context === this.context;
    equals &= model.sportType?.id === this.sportType?.id;

    return equals;
  }

  isLinkTag(date: Date): Boolean {
    const diffDays: Number = this.datetimeUtils.diffDaysByDate(date, new Date());
    const onDateRage: Boolean = diffDays <= this.config.nextDaysAmountToBeLink && diffDays >= this.config.prevDaysAmountToBeLink;
    const isMajorSportType: Boolean = HREF_SPORT_TYPES[this.appState.context.sportType?.nameForURL] > 0;
    const isMainLang: Boolean = languages.filter(lang => lang.isMain).map(lang => lang.id).includes(this.language?.id)

    const isLinkTag: Boolean = onDateRage && isMajorSportType && isMainLang;

    return isLinkTag;
  }

  @computed get nextLinkModel(): AllScoresLinkModel {
    if(!this.date) {
      return null;
    }

    const filter: String = this.datetimeUtils.isToday(this.nextDate) ? DASHBOARD.FILTERS.all : this.datetimeUtils.toURLDate(this.nextDate);
    const nextDayLinkModel: AllScoresLinkModel = new AllScoresLinkModel(filter, this.appState?.context.sportType?.nameForURL, false, false, this.isLinkTag(this.nextDate));

    return nextDayLinkModel;
  }

  @computed get previousLinkModel(): AllScoresLinkModel {
    if (!this.date) {
      return null;
    }

    const filter: String = this.datetimeUtils.isToday(this.previousDate) ? DASHBOARD.FILTERS.all : this.datetimeUtils.toURLDate(this.previousDate);
    const previousDayLinkModel: AllScoresLinkModel = new AllScoresLinkModel(filter, this.appState?.context.sportType?.nameForURL, false, false, this.isLinkTag(this.previousDate));

    return previousDayLinkModel;
  }

  get nextDate(): Date {
    return this.datetimeUtils.addDays(this.date, 1)
  }

  get previousDate(): Date {
    return this.datetimeUtils.addDays(this.date, -1)
  }
}
